exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".webapp-device-ios .iphone-x>.l-navbar{height:84px!important}.webapp-device-ios .isrunwork2>.l-navbar{height:44px!important}", ""]);

// exports
